/*
 * Copyright (C) 2023 Airfordable, Inc - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */

import { TINYURL_API_KEY } from 'utils/constants';

/** Create a TinyURL from a given long URL. */
async function createTinyLink(url: string): Promise<string | undefined> {
  const response = await fetch('https://api.tinyurl.com/create', {
    body: JSON.stringify({ domain: 'airfordable.link', url }),
    headers: {
      Authorization: `Bearer ${TINYURL_API_KEY}`,
      'Content-Type': 'application/json',
    },
    method: 'POST',
  });

  if (!response.ok) {
    return undefined;
  }

  const json = await response.json();
  return json?.data?.tiny_url;
}

export { createTinyLink };
